import { fromJS } from 'immutable'
import {
  CLIENT_MASTER_EDIT_REQUEST,
  CLIENT_MASTER_EDIT_SUCCESS,
  CLIENT_MASTER_EDIT_FAILURE,
  CLIENT_MASTER_EDIT_RESET,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CLIENT_MASTER_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case CLIENT_MASTER_EDIT_SUCCESS:
      return state
        .set('updatedClient', fromJS(action.payload.updatedClient))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case CLIENT_MASTER_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('updatedClient', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case CLIENT_MASTER_EDIT_RESET:
      return state
        .delete('updatedClient')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/client/client-master-edit-reducer.js